export default __webpack_public_path__ + "static/media/founders-grotesk-test-semibold.745165d7.woff";